import { render, staticRenderFns } from "./ListCustomer.vue?vue&type=template&id=500c4c6a&scoped=true&"
import script from "./ListCustomer.vue?vue&type=script&lang=js&"
export * from "./ListCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500c4c6a",
  null
  
)

export default component.exports